import { animate, style, transition, trigger } from '@angular/animations';

export const popupAnimation = trigger('popup', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.5)' }),
    animate('100ms 100ms', style({ opacity: 1, transform: 'scale(1)' })),
  ]),
  transition(':leave', [animate('200ms', style({ opacity: 0, transform: 'scale(0.5)' }))]),
]);
